export default __webpack_public_path__ + "static/media/slider-main-icon-2.8222d7da.svg";